import { Helmet } from 'react-helmet-async';
import { Container, Typography, Grid, Alert, Button } from '@mui/material';
import ZapierIntegration from '../sections/@dashboard/settings/ZapierIntegration';
import ApiKeyManager from '../sections/@dashboard/settings/ApiKeyManager';

const ZAPIER_INVITE_URL = 'https://zapier.com/developer/public-invite/213902/e20f07f0bd144a12374ba41234546669/';

export default function IntegrationsPage() {
  return (
    <>
      <Helmet>
        <title>Integrations | {localStorage.getItem("companyName") ?? "FlowBookings"}</title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 3 }}>
          Integrations
        </Typography>

        <Alert
          severity="warning"
          sx={{ mb: 4, alignItems: 'center', paddingTop: '8px', paddingBottom: '8px' }}
          action={
            <Button
              color="success"
              size="medium"
              variant="contained"
              href={ZAPIER_INVITE_URL}
              target="_blank"
              rel="noopener"
              sx={{ whiteSpace: 'nowrap' }}
            >
              Accept Zapier Invite →
            </Button>
          }
        >
          FlowBookings Zapier integration is currently in beta. You'll need to accept the invite before you can connect.
        </Alert>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <ApiKeyManager />
          </Grid>
          <Grid item xs={12} md={6}>
            <ZapierIntegration />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}